import axios from "axios";
import { baseURL } from "../../../../utils/http/http-common";

export const getMeghalayaTeacherDetails = async (teacherId) => {
  try {
    const response = await axios.get(
      `${baseURL}/Login/GetMeghalayaTeacherDetail/${teacherId}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error fetching Meghalaya teacher details:", error);
  }
};

export const verifyTeacherIdGcsess = async (teacherId) => {
  try {
    const response = await axios.get(
      `${baseURL}/Login/VerifyTeacherIdGCSESS/${teacherId}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error fetching Meghalaya teacher details:", error);
  }
};